import styled from "styled-components/macro";
import { device } from "../../device";

export const StyledInfographic = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    padding-top: 100%;
    display: block;
  }
`;

export const Summary = styled.div`
  font-size: 0.75rem;
  color: #dfdad5;
`;

export const Content = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  /* flex-wrap:wrap; */
`;

export const Heading = styled.h2`
  padding: 0;
  margin: 0;
  font-size: 0.8rem;
  font-weight: bold;
  width: 100%;
  color: ${(props) => props.color};
  line-height: 1;
  @media ${device.mobileL} {
    font-size: 1.2rem;
  }
`;

export const Value = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  width: 100%;
  line-height: 1;
  color: ${(props) => props.color};
  @media ${device.mobileL} {
    font-size: 2.5rem;
  }
`;

export const ImageWrapper = styled.div`
  margin-left: ${(props) => (props.position === "left" ? "0" : "auto")};
  margin-right: ${(props) => (props.position === "right" ? "0" : "auto")};
  text-align: ${(props) => (props.position === "right" ? "right" : "left")};
  overflow: hidden;
  margin-top: auto;
  max-width: 120px;
  @media ${device.mobileL} {
    max-width: 180px;
  }
`;
export const ContentWrapper = styled.div`
  /* flex-wrap:wrap; */
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  @media ${device.mobileL} {
    padding-top: 25px;
    padding-bottom: 25px;
    padding-right: 25px;
    padding-left: 25px;
  }
`;
